import { axiosRequest } from "./utils/axios";
import { API_BASE } from "../constants";

export const getMergeDetails = async () => {
    const response = await axiosRequest.get(`${API_BASE}/mergeDetails/`);
    return response;
}